<template>
  <nav class="mobile-tabbar" aria-label="移动端主导航">
    <RouterLink class="mobile-tab" :class="{ active: active === 'home' }" to="/mobile">
      <svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 11 12 4l8 7v8a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 19z" /><path d="M9.5 20.5v-6h5v6" /></svg>
      <span>首页</span>
    </RouterLink>
    <RouterLink class="mobile-tab" :class="{ active: active === 'vitaeai' }" to="/mobile/employee">
      <svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><rect x="5" y="7" width="14" height="11" rx="3.5" /><circle cx="9.4" cy="12.2" r="1.4" fill="currentColor" stroke="none" /><circle cx="14.6" cy="12.2" r="1.4" fill="currentColor" stroke="none" /><path d="M9.5 15.6h5M12 7V4.2" /></svg>
      <span>VitaeAI</span>
    </RouterLink>
    <RouterLink class="mobile-tab" :class="{ active: active === 'app' }" to="/mobile/app">
      <svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><rect x="7.5" y="2.5" width="9" height="19" rx="2.5" /><path d="M10.8 18.8h2.4" /></svg>
      <span>点指之间</span>
    </RouterLink>
    <RouterLink class="mobile-tab" :class="{ active: active === 'about' }" to="/mobile/about">
      <svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20V6.5A2.5 2.5 0 0 1 6.5 4h7A2.5 2.5 0 0 1 16 6.5V20" /><path d="M16 9h2.5A2.5 2.5 0 0 1 21 11.5V20" /><path d="M3 20h18M8 8h5M8 12h5M8 16h5" /></svg>
      <span>公司简介</span>
    </RouterLink>
    <RouterLink class="mobile-tab" :class="{ active: active === 'user' }" to="/mobile/user">
      <svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="8" r="3.6" /><path d="M4.5 20c1.4-3.6 4.2-5.2 7.5-5.2s6.1 1.6 7.5 5.2" /></svg>
      <span>我的</span>
    </RouterLink>
  </nav>
</template>

<script setup>
defineProps({
  active: { type: String, required: true }
})
</script>
